import { InputSwitch } from "primereact/inputswitch";

interface OurSwitchInputProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export default function OurSwitchInput({ value, onChange }: OurSwitchInputProps) {
  return (
    <InputSwitch className="OurSwitchInput" checked={value} onChange={(e) => onChange(e.value)} />
  );
}
